module.exports = __webpack_public_path__ + "img/surgery.85f2eb7b.svg";